import VariableDialog from '@/components/variables/VariableDialog';
import { SearchBlocksItem } from '@/types/search';
import { VariableScope } from '@/types/variable';
import { DataObject } from '@mui/icons-material';
import BuildIcon from '@mui/icons-material/Build';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import RouteIcon from '@mui/icons-material/Route';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import TaskIcon from '@mui/icons-material/Task';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

type TreeVariablesProps = {
  onVariableSearch: (searchValue: SearchBlocksItem) => void;
};

const TreeVariables: FC<TreeVariablesProps> = (props) => {
  const [open, setOpen] = useState(false);
  const [scope, setScope] = useState<VariableScope>('global');

  const openDialog = (scope: VariableScope) => {
    setScope(scope);
    setOpen(true);
  };

  return (
    <StyledTreeItem itemId='variables' label={<TreeLabel icon={DataObject} label='Variables' />}>
      <StyledTreeItem
        itemId='variables.config'
        label={<TreeLabel icon={BuildIcon} label='Config' />}
        onClick={() => openDialog('config')}
      />
      <StyledTreeItem
        itemId='variables.global'
        label={<TreeLabel icon={PublicIcon} label='Global' />}
        onClick={() => openDialog('global')}
      />
      <StyledTreeItem
        itemId='variables.task'
        label={<TreeLabel icon={TaskIcon} label='Task' />}
        onClick={() => openDialog('task')}
      />
      <StyledTreeItem
        itemId='variables.channel'
        label={<TreeLabel icon={RouteIcon} label='Channel' />}
        onClick={() => openDialog('channel')}
      />
      <StyledTreeItem
        itemId='variables.session'
        label={<TreeLabel icon={SettingsPhoneIcon} label='Session' />}
        onClick={() => openDialog('session')}
      />
      <StyledTreeItem
        itemId='variables.local'
        label={<TreeLabel icon={PlaceIcon} label='Local' />}
        onClick={() => openDialog('local')}
      />
      <VariableDialog
        open={open}
        onClose={() => setOpen(false)}
        scope={scope}
        onVariableSearch={props.onVariableSearch}
      />
    </StyledTreeItem>
  );
};

export default TreeVariables;
